import React from 'react'

import PromotionsContainer from '../components/promotions/PromotionsContainer'

const PromotionsScreen = props => <PromotionsContainer {...props} />

export default PromotionsScreen
